export const nominations = [
  {
    brandName: 'CHOPARD',
    productName: 'VCHL48',
    categoryCode: '01',
    categoryName: 'VP-001 Best New Spectacle Frame (Luxury)',
    distributor: 'De Rigo Vision Middle east FZCO.',
    productCode: '01-01',
    productImage: '01-01.jpg',
    pdf: '',
    price: '1062',
    ID: '01-01',
    brandLogo: '01-01-logo.jpg',
    productDescription:
      'High quality metal temples milled to create the space for the thick material insert hexagonal screws with honeycomb engraving integrated flex hinge. Honeycomb pattern engraved in the inner temple.',
    distributorEmail: 'mukil.somadas@derigome.com',
  },
  {
    brandName: 'LUNETTERIE GÉNÉRALE',
    productName: 'LG ALLTIME',
    categoryCode: '01',
    categoryName: 'VP-001 Best New Spectacle Frame (Luxury)',
    distributor: 'Idol Optics LLC',
    productCode: '01-02',
    productImage: '01-02.jpg',
    pdf: '',
    price: '1000',
    ID: '01-02',
    brandLogo: '01-02-logo.jpg',
    productDescription:
      'Founded: 2018 by designer Julien Couture Brand Vision: Creates wearable works of art inspired by cultural icons Design Philosophy: Fuses French refinement with the bold spirit of American culture.',
    distributorEmail: 'rawan@idoloptic.com',
  },
  {
    brandName: 'LUNETTERIE GÉNÉRALE',
    productName: 'LG ROMEO',
    categoryCode: '01',
    categoryName: 'VP-001 Best New Spectacle Frame (Luxury)',
    distributor: 'Idol Optics LLC',
    productCode: '01-03',
    productImage: '01-03.jpg',
    pdf: '',
    price: '1160',
    ID: '01-03',
    brandLogo: '01-03-logo.jpg',
    productDescription:
      'Inspired by the beauty of life, we pay homage to the timeless elegance of the past through exceptional craftsmanship and a visionary aesthetic.',
    distributorEmail: 'rawan@idoloptic.com',
  },
  {
    brandName: 'ØRGREEN OPTICS',
    productName: 'INNER CIRCLE 3D RING',
    categoryCode: '01',
    categoryName: 'VP-001 Best New Spectacle Frame (Luxury)',
    distributor: 'Ørgreen Optics',
    productCode: '01-04',
    productImage: '01-04.jpg',
    pdf: '',
    price: '450',
    ID: '01-04',
    brandLogo: '01-04-logo.jpg',
    productDescription:
      "The IMAGINARY LINES collection re-interprets premium quality Japanese titanium, bringing Ørgreen's metal expertise to its thinnest and most minimalist expression. A growing portfolio of timeless silhouettes realized in a selection of vibrant and muted hues. Balancing comfort and design.",
    distributorEmail: 'mattia@orgreenoptics.com',
  },
  {
    brandName: 'ROLF EYEWEAR',
    productName: 'CHARLSTON',
    categoryCode: '01',
    categoryName: 'VP-001 Best New Spectacle Frame (Luxury)',
    distributor: 'Rolf produktion GmbH',
    productCode: '01-05',
    productImage: '01-05.jpg',
    pdf: '',
    price: '1582',
    ID: '01-05',
    brandLogo: '01-05-logo.jpg',
    productDescription:
      'Handcrafted in Austria, Rolf wooden glasses turn nature into luxury. Each frame is shaped from hand-selected woods, with unique grain and color. Minimalist, screwless design meets timeless craftsmanship - eyewear as individual as its wearer.',
    distributorEmail: 'marketing@rolf-spectacles.com',
  },
  {
    brandName: 'BOLON',
    productName: 'BA6006',
    categoryCode: '02',
    categoryName: 'VP-002 Best New Spectacle Frame (Designer)',
    distributor: 'Idol Optics LLC',
    productCode: '02-01',
    productImage: '02-01.jpg',
    pdf: '',
    price: '200',
    ID: '02-01',
    brandLogo: '02-01-logo.jpg',
    productDescription:
      'Drawing inspiration from the new leaders of today, Bolon Eyewear is dedicated to constantly challenge and lead ever-changing trends by producing the widest and finest array of products catering to all identities.',
    distributorEmail: 'connect@idoloptic.com',
  },
  {
    brandName: 'BOSS',
    productName: '1878',
    categoryCode: '02',
    categoryName: 'VP-002 Best New Spectacle Frame (Designer)',
    distributor: 'Safilo Middle East FZCO',
    productCode: '02-02',
    productImage: '02-02.jpg',
    pdf: '',
    price: '250',
    ID: '02-02',
    brandLogo: '02-02-logo.jpg',
    productDescription:
      'These high-performance BOSS optical glasses and their premium character derives from the use of titanium, a hypo-allergenic and flexible material known for its lightness. Essential lines, minimalist hinges and a fine laser-engraved logo are key elements which define this accessory.',
    distributorEmail: 'paola.kanta@safilo.com',
  },
  {
    brandName: 'CAROLINA HERRERA',
    productName: 'HER 0325',
    categoryCode: '02',
    categoryName: 'VP-002 Best New Spectacle Frame (Designer)',
    distributor: 'Safilo Middle East FZCO',
    productCode: '02-03',
    productImage: '02-03.jpg',
    pdf: '',
    price: '280',
    ID: '02-03',
    brandLogo: '02-03-logo.jpg',
    productDescription:
      'A signature of timeless sophistication, the House of Herrera eyewear collection offers sculptural volumes and refined comfort. The flat, rounded temples are enhanced with patterned or colour-block inserts for a richly graphic look.',
    distributorEmail: 'paola.kanta@safilo.com',
  },
  {
    brandName: 'PATTY SHELABARGER',
    productName: 'SHANTI',
    categoryCode: '02',
    categoryName: 'VP-002 Best New Spectacle Frame (Designer)',
    distributor: 'Patty Shelabarger',
    productCode: '02-04',
    productImage: '02-04.jpg',
    pdf: '',
    price: '550',
    ID: '02-04',
    brandLogo: '02-04-logo.jpg',
    productDescription:
      'Made-in-Italy limited edition model. Manufactured by hand with custom-made 3-layer Mazzuchelli acetate exclusive to the Patty Shelabarger brand.',
    distributorEmail: 'info@pattyshelabarger.com',
  },
  {
    brandName: 'ROBERTO CAVALLI',
    productName: 'VRC120',
    categoryCode: '02',
    categoryName: 'VP-002 Best New Spectacle Frame (Designer)',
    distributor: 'De Rigo Vision Middle east FZCO.',
    productCode: '02-05',
    productImage: '02-05.jpg',
    pdf: '',
    price: '477',
    ID: '02-05',
    brandLogo: '02-05-logo.jpg',
    productDescription: 'Temple design inspired from the Roberto Cavalli Belt Nuckle',
    distributorEmail: 'mukil.somadas@derigome.com',
  },
  {
    brandName: 'IC! BERLIN',
    productName: 'IC5326 GALLIUM',
    categoryCode: '03',
    categoryName: 'VP-003 Best New Spectacle Frame (Niche)',
    distributor: 'Marcolin Middle East',
    productCode: '03-01',
    productImage: '03-01.jpg',
    pdf: '',
    price: '136',
    ID: '03-01',
    brandLogo: '03-01-logo.jpg',
    productDescription:
      "Gallium by ic! Berlin - A refined round frame with a precision-milled stainless-steel front in rich Teak PVD and striking Shiny Copper PVD temples. Lightweight yet durable, Gallium embodies ic! Berlin's signature blend of innovation, craftsmanship and modern design.",
    distributorEmail: 'ali.laila@marcolin-me.com',
  },
  {
    brandName: 'MONOGRAM',
    productName: 'PRL210',
    categoryCode: '03',
    categoryName: 'VP-003 Best New Spectacle Frame (Niche)',
    distributor: 'Monogram Eyewear Fzco',
    productCode: '03-02',
    productImage: '03-02.jpg',
    pdf: '',
    price: '410',
    ID: '03-02',
    brandLogo: '03-02-logo.jpg',
    productDescription:
      'PRL is a new monogram line that reflect the brand identity in term on innovation and hand crafting and dedicated for people who like the straight lines and minimalistic designs. Moreover ,the fitting technique is very easy to implement by technician.',
    distributorEmail: 'merce.deluca@etnia.es',
  },
  {
    brandName: 'PELLICER BY ETNIA BARCELONA',
    productName: 'GUIMERA GREY HAVANA',
    categoryCode: '03',
    categoryName: 'VP-003 Best New Spectacle Frame (Niche)',
    distributor: 'Etnia Eyewear Culture',
    productCode: '03-03',
    productImage: '03-03.jpg',
    pdf: '',
    price: '517',
    ID: '03-03',
    brandLogo: '03-03-logo.jpg',
    productDescription:
      "Innovative frame 2 glasses in 1: Metal frame integrated between two Mazzucchelli acetate laminates. Minimal thickness and superior strength and hardness. Patented screwless hinge. Bridge inspired by the 'pince-nez' effect from the 19th century.",
    distributorEmail: 'marketing@rolf-spectacles.com',
  },
  {
    brandName: 'ROLF EYEWEAR',
    productName: 'SUBSTANCE | LIOR',
    categoryCode: '03',
    categoryName: 'VP-003 Best New Spectacle Frame (Niche)',
    distributor: 'Rolf produktion GmbH',
    productCode: '03-04',
    productImage: '03-04.jpg',
    pdf: '',
    price: '540',
    ID: '03-04',
    brandLogo: '03-04-logo.jpg',
    productDescription:
      'Bold yet playful contours balance individuality with refinement. Distinctive edges give strong identity, while soft transitions and subtle asymmetries add lightness. A frame that stands out quietly - stylish with a subtle twist.',
    distributorEmail: 'marketing@rolf-spectacles.com',
  },
  {
    brandName: 'SILHOUETTE',
    productName: 'THE VISIONARY 5586',
    categoryCode: '03',
    categoryName: 'VP-003 Best New Spectacle Frame (Niche)',
    distributor: 'Silhouette International Schmied AG',
    productCode: '03-05',
    productImage: '03-05.jpg',
    pdf: '',
    price: '640',
    ID: '03-05',
    brandLogo: '03-05-logo.jpg',
    productDescription:
      "The Visionary - Silhouette's bold new take on rimless eyewear, crafted from ultra-light titanium with a statement design that feels distinctly now. Its expressive new nose bridge and flat lenses define a truly distinctive character. Designed to stand out while delivering effortless comfort.",
    distributorEmail: 'e.capaldi@ae.silhouette.com',
  },
  {
    brandName: 'JOHANN VON GOISERN',
    productName: 'JVG ART 039',
    categoryCode: '04',
    categoryName: 'VP-004 Best New Spectacle Frame (Popular)',
    distributor: 'Pomberger Goisern GmbH',
    productCode: '04-01',
    productImage: '04-01.jpg',
    pdf: '',
    price: '119',
    ID: '04-01',
    brandLogo: '04-01-logo.jpg',
    productDescription:
      'The JVG Art 039 A150 combines striking colors with an unconventional frame concept. Its innovative - never seen before - floating lens design breaks the boundaries between frame and glass. A daring design that blends art, style, and individuality, made to stand out.',
    distributorEmail: 'dominik@pomberger.com',
  },
  {
    brandName: 'LOOL EYEWEAR',
    productName: '9 HANGAR 47O',
    categoryCode: '04',
    categoryName: 'VP-004 Best New Spectacle Frame (Popular)',
    distributor: 'Etnia Eyewear Culture S.L',
    productCode: '04-02',
    productImage: '04-02.jpg',
    pdf: '',
    price: '349',
    ID: '04-02',
    brandLogo: '04-02-logo.jpg',
    productDescription:
      'HANGAR is a timeless pantos shape, lightweight and effortlessly stylish. Innovative, with a unique combination of Cromalyt® + β-Titanium, a patented hinge and cutting-edge technology, resulting in one of the lightest and most comfortable frames ever created by Lool Eyewear.',
    distributorEmail: 'export@etnia.es',
  },
  {
    brandName: 'ORCADIA',
    productName: '2492',
    categoryCode: '04',
    categoryName: 'VP-004 Best New Spectacle Frame (Popular)',
    distributor: 'Mada Al Hayat Trading',
    productCode: '04-03',
    productImage: '04-03.jpg',
    pdf: '',
    price: '100',
    ID: '04-03',
    brandLogo: '04-03-logo.jpg',
    productDescription:
      'Flexible, lightweight, anti-blue light lenses, comfort fitting, have warranty one year, it can be used for eye protection for computers and all smart screen.',
    distributorEmail: 'info@madaalhayat.com',
  },
  {
    brandName: 'POLICE',
    productName: 'VPLQ76V',
    categoryCode: '04',
    categoryName: 'VP-004 Best New Spectacle Frame (Popular)',
    distributor: 'De Rigo Vision Middle east FZCO.',
    productCode: '04-04',
    productImage: '04-04.jpg',
    pdf: '',
    price: '340',
    ID: '04-04',
    brandLogo: '04-04-logo.jpg',
    productDescription:
      'New distinctive eagle-style temple design with pierced design. Distinctive geometric shapes and unique details. Premium design features such as titanium trims.',
    distributorEmail: 'mukil.somadas@derigome.com',
  },
  {
    brandName: 'STEPPER',
    productName: 'SI-11578',
    categoryCode: '04',
    categoryName: 'VP-004 Best New Spectacle Frame (Popular)',
    distributor: 'Future Optics Co. L.L.C',
    productCode: '04-05',
    productImage: '04-05.jpg',
    pdf: '',
    price: '250',
    ID: '04-05',
    brandLogo: '04-05-logo.jpg',
    productDescription:
      'It is a lady Titanium rimless model having spring hinges with only 6.7 grams in weight. This hypoallergenic frame is an authentic ophthalmic brand that understands eye care. Each frame is accompanied by a hard case, a microfibre cleaning cloth and a niche paper carry bag.',
    distributorEmail: 'info@futureopticsuae.com',
  },
  {
    brandName: 'CARTIER',
    productName: 'CLASH DE CARTIER',
    categoryCode: '05',
    categoryName: 'VP-005 Best New Sunglass Model (Luxury)',
    distributor: 'Kering Eyewear Middle East',
    productCode: '05-01',
    productImage: '05-01.jpg',
    pdf: '',
    price: '2195',
    ID: '05-01',
    brandLogo: '05-01-logo.jpg',
    productDescription:
      'The debut of the Clash de Cartier frames pays homage to the exquisite techniques of the jewellery collection, while appealing to a diverse audience drawn to timeless yet daring accessories.',
    distributorEmail: 'valerie.vanlangenhove@kering.com',
  },
  {
    brandName: 'CHOPARD',
    productName: 'SCHL82',
    categoryCode: '05',
    categoryName: 'VP-005 Best New Sunglass Model (Luxury)',
    distributor: 'De Rigo Vision Middle east FZCO.',
    productCode: '05-02',
    productImage: '05-02.jpg',
    pdf: '',
    price: '3131',
    ID: '05-02',
    brandLogo: '05-02-logo.jpg',
    productDescription:
      'Limited edition, 299 pcs. Mineral barberini polar lenses, fully covererd by walnut wood, tyre pattern engraving and the double integrated flex hinge.',
    distributorEmail: 'mukil.somadas@derigome.com',
  },
  {
    brandName: 'FERRAGAMO',
    productName: 'SF2082SE',
    categoryCode: '05',
    categoryName: 'VP-005 Best New Sunglass Model (Luxury)',
    distributor: 'Marchon Gulf Fzco',
    productCode: '05-03',
    productImage: '05-03.jpg',
    pdf: '',
    price: '350',
    ID: '05-03',
    brandLogo: '05-03-logo.jpg',
    productDescription:
      'The iconic Gancini element of the Maison is reinterpreted through a modern,sophisticated design philosophy. The new Gancini chain is functionally integrated into the temples,incorporating the hinge.The style is crafted using Recycled Acetate Renew and stands as a true emblem of Italian craftsmanship.',
    distributorEmail: 'cfullin@marchon.com',
  },
  {
    brandName: 'MAYBACH EYEWEAR',
    productName: 'THE ARTIST SUN II',
    categoryCode: '05',
    categoryName: 'VP-005 Best New Sunglass Model (Luxury)',
    distributor: 'Yateem Vision',
    productCode: '05-04',
    productImage: '05-04.jpg',
    pdf: '',
    price: '3400',
    ID: '05-04',
    brandLogo: '05-04-logo.jpg',
    productDescription:
      "MAYBACH Eyewear Presents 'The Artist Sun II' - A Vision of Luxury and Innovation. MAYBACH, synonymous with uncompromising excellence and visionary design, proudly unveils its latest creation: The Artist Sun II. This exceptional pair of sunglasses embodies the spirit of craftsmanship, individuality, and artistry for which the MAYBACH name stands worldwide. At the heart of The Artist Sun II lies a striking front crafted from lightweight titanium, meticulously refined through a platinum galvanization process. The result is a subtle yet radiant brilliance that highlights the purity of the material while ensuring exceptional durability and comfort. The temples elevate the design into the realm of true artistry. Constructed from laminated fine wood, they are finished with an exclusive two-tone lacquer that recreates the elegant Sand-Onyx colorway. This palette is inspired by a distinguished MAYBACH special edition vehicle - a design shaped by the creative influence of the late Virgil Abloh. With this reference, The Artist Sun II transcends conventional eyewear and establishes itself as a collector's piece for connoisseurs of design and culture alike. Every detail reflects the philosophy of MAYBACH: to craft not just an accessory, but an expression of character. The Artist Sun II is a statement of refinement, innovation, and timeless luxury - a wearable work of art for those who demand more than vision. MAYBACH - The Artist Sun II. A masterpiece for those who live without compromise.",
    distributorEmail: 'mathews@yateemgroup.ae',
  },
  {
    brandName: 'SILHOUETTE',
    productName: 'SPLENDEUR EXCLUSIVE SOLAIRE L900',
    categoryCode: '05',
    categoryName: 'VP-005 Best New Sunglass Model (Luxury)',
    distributor: 'Silhouette International Schmied AG',
    productCode: '05-05',
    productImage: '05-05.jpg',
    pdf: '',
    price: '1875',
    ID: '05-05',
    brandLogo: '05-05-logo.jpg',
    productDescription:
      'Limited to just 250 pieces, Splendeur Exclusive Solaire offers an extraordinary experience. Crafted from cutting-edge 3D printed titanium, seamlessly paired with 23-kt gold and polarized sun lenses. This exclusive model embodies innovation, meticulous craftmanship and contemporary refinement.',
    distributorEmail: 'e.capaldi@ae.silhouette.com',
  },
  {
    brandName: 'BOLON',
    productName: 'BX7000',
    categoryCode: '06',
    categoryName: 'VP-006 Best New Sunglass Model (Designer)',
    distributor: 'Idol Optics LLC',
    productCode: '06-01',
    productImage: '06-01.jpg',
    pdf: '',
    price: '240',
    ID: '06-01',
    brandLogo: '06-01-logo.jpg',
    productDescription:
      'Bolon Eyewear offers the perfect combination of premium, fashionable design and high-quality eyewear at affordable prices, trading up the eyewear offer in the mid-tier segment',
    distributorEmail: 'rawan@idoloptic.com',
  },
  {
    brandName: 'BOSS',
    productName: '1853',
    categoryCode: '06',
    categoryName: 'VP-006 Best New Sunglass Model (Designer)',
    distributor: 'Safilo Middle East FZCO',
    productCode: '06-02',
    productImage: '06-02.jpg',
    pdf: '',
    price: '300',
    ID: '06-02',
    brandLogo: '06-02-logo.jpg',
    productDescription:
      'Striking yet refined style characterises these BOSS sunglasses. Crafted in sustainable materials, they come in intense hues with a polished finish. As the finishing touch, BOSS has added its iconic metal detail with three stripes and a foil-effect logo.',
    distributorEmail: 'paola.kanta@safilo.com',
  },
  {
    brandName: 'CARRERA',
    productName: '1053',
    categoryCode: '06',
    categoryName: 'VP-006 Best New Sunglass Model (Designer)',
    distributor: 'Safilo Middle East FZCO',
    productCode: '06-03',
    productImage: '06-03.jpg',
    pdf: '',
    price: '422',
    ID: '06-03',
    brandLogo: '06-03-logo.jpg',
    productDescription:
      'The structure in titanium - an ultralight premium material - makes these CARRERA sunglasses special, with a high-impact acetate coating. Flex hinges, adjustable nose pads blended with Carrera iconic boldness make it a pair to wear at all times.',
    distributorEmail: 'paola.kanta@safilo.com',
  },
  {
    brandName: 'LEANDRO LOPES EYEWEAR',
    productName: 'LL004 PEARL',
    categoryCode: '06',
    categoryName: 'VP-006 Best New Sunglass Model (Designer)',
    distributor: 'Raze Eyewear Distribution FZCO',
    productCode: '06-04',
    productImage: '06-04.jpg',
    pdf: '',
    price: '530',
    ID: '06-04',
    brandLogo: '06-04-logo.jpg',
    productDescription:
      'Rimless Sunglasses, with custom, style lenses, diamond cut, bevel cut, nice gradient modern colors. flex hinges',
    distributorEmail: 'info@djraze.com',
  },
  {
    brandName: 'ROBERTO CAVALLI',
    productName: 'SRC098S',
    categoryCode: '06',
    categoryName: 'VP-006 Best New Sunglass Model (Designer)',
    distributor: 'De Rigo Vision Middle east FZCO.',
    productCode: '06-05',
    productImage: '06-05.jpg',
    pdf: '',
    price: '1498',
    ID: '06-05',
    brandLogo: '06-05-logo.jpg',
    productDescription:
      'High craftsmanship and ultra luxury tiger motif, inspired by The Roar Bag of Roberto Cavalli. The tiger metal embellishment is also functional, the hinge is here integrated',
    distributorEmail: 'mukil.somadas@derigome.com',
  },
  {
    brandName: 'GALFER EYEWEAR',
    productName: 'JIGUERAS',
    categoryCode: '07',
    categoryName: 'VP-007 Best New Sunglass Model (Niche)',
    distributor: 'Galferdexign UG',
    productCode: '07-01',
    productImage: '07-01.jpg',
    pdf: '',
    price: '290',
    ID: '07-01',
    brandLogo: '07-01-logo.jpg',
    productDescription:
      'Jigueras is a design frame inspired by the molding branches of a Spanish tree called Higuera from Extremadura. It has a recognizable silhouette and innovative aspects such as its floating stainless steel structure as the styling dna of our brand. Iconic, elegant and minimal',
    distributorEmail: 'info@galferdexign.com',
  },
  {
    brandName: 'IC! BERLIN',
    productName: 'RHENIUM IC0069',
    categoryCode: '07',
    categoryName: 'VP-007 Best New Sunglass Model (Niche)',
    distributor: 'Marcolin Middle East',
    productCode: '07-02',
    productImage: '07-02.jpg',
    pdf: '',
    price: '76',
    ID: '07-02',
    brandLogo: '07-02-logo.jpg',
    productDescription:
      "Rhenium by ic! Berlin - A sleek aviator crafted from stainless steel with a matte bronze PVD front, shiny bronze PVD temples and striking cactus gradient lenses. Lightweight yet resilient, it blends ic! Berlin's hallmark engineering with timeless, contemporary style.",
    distributorEmail: 'ali.laila@marcolin-me.com',
  },
  {
    brandName: 'MATSUDA',
    productName: 'M3148',
    categoryCode: '07',
    categoryName: 'VP-007 Best New Sunglass Model (Niche)',
    distributor: 'Optitalia Group',
    productCode: '07-03',
    productImage: '07-03.jpg',
    pdf: '',
    price: '1102',
    ID: '07-03',
    brandLogo: '07-03-logo.jpg',
    productDescription:
      'A technical marvel, the M3148 features a unique flip-up sunglass lens. Hand crafted in Japan from high-grade titanium with engraved temples and hand applied lacquer details. Art Deco Inspired Decor. Hand Applied Lacquer Details. Precious Metal Finishing. Made in Japan.',
    distributorEmail: 'federica@optitaliagroup.com',
  },
  {
    brandName: 'MOVITRA',
    productName: 'TRINITAS 01',
    categoryCode: '07',
    categoryName: 'VP-007 Best New Sunglass Model (Niche)',
    distributor: 'Vision Eye Wear FZE',
    productCode: '07-04',
    productImage: '07-04.jpg',
    pdf: '',
    price: '965',
    ID: '07-04',
    brandLogo: '07-04-logo.jpg',
    productDescription:
      'TRINITAS represents three-in-one excellence: a pioneering triple-layer titanium construction, secured with exposed screws and bushings, and paired with a new adjustable-length temple for precision, strength, and versatility.',
    distributorEmail: 'ANNA@VISIONEYEWEAR.AE',
  },
  {
    brandName: 'SILHOUETTE',
    productName: 'NOVA SHADES - RINCON 8746',
    categoryCode: '07',
    categoryName: 'VP-007 Best New Sunglass Model (Niche)',
    distributor: 'Silhouette International Schmied AG',
    productCode: '07-05',
    productImage: '07-05.jpg',
    pdf: '',
    price: '490',
    ID: '07-05',
    brandLogo: '07-05-logo.jpg',
    productDescription:
      'The Nova Shades collection combines minimalist purity with high-tech polish. Flat, futuristic lens shapes, precious titanium and innovative lens colors capture the aesthetic of modern cinematic effects. The new Space Blue lens with silver titanium metalwork turns this shape into a classy icon.',
    distributorEmail: 'e.capaldi@ae.silhouette.com',
  },
  {
    brandName: 'DAMAS EYEWEAR',
    productName: 'DMS1004',
    categoryCode: '08',
    categoryName: 'VP-008 Best New Sunglass Model (Popular)',
    distributor: 'Vision Trade srl',
    productCode: '08-01',
    productImage: '08-01.jpg',
    pdf: '',
    price: '220',
    ID: '08-01',
    brandLogo: '08-01-logo.jpg',
    productDescription:
      'The DMS1004S color 01 combines a geometric silhouette with timeless elegance. Featuring ultra-light gold-tone steel frames and bold dark green lenses, this model balances clean lines with a contemporary edge. The use of steel ensures exceptional lightness and lasting durability.',
    distributorEmail: 'cristina@visiontrade.it',
  },
  {
    brandName: 'MAUI JIM',
    productName: "HO'OKIPA ULTRA",
    categoryCode: '08',
    categoryName: 'VP-008 Best New Sunglass Model (Popular)',
    distributor: 'Kering Eyewear Middle East',
    productCode: '08-02',
    productImage: '08-02.jpg',
    pdf: '',
    price: '269',
    ID: '08-02',
    brandLogo: '08-02-logo.jpg',
    productDescription:
      "A contemporary sporty evolution of the best-seller Ho'okipa, Ho'okipa Ultra is updated with curving temples and the signature Wavy Pattern on the nose pads and temple tips. Designed with Maui Ultra, move confidently with an ultra-durable and ultra-light lens on your most dynamic outdoor activities.",
    distributorEmail: 'valerie.vanlangenhove@kering.com',
  },
  {
    brandName: 'POLICE',
    productName: 'SPLQ91',
    categoryCode: '08',
    categoryName: 'VP-008 Best New Sunglass Model (Popular)',
    distributor: 'De Rigo Vision Middle East FZCO.',
    productCode: '08-03',
    productImage: '08-03.jpg',
    pdf: '',
    price: '286',
    ID: '08-03',
    brandLogo: '08-03-logo.jpg',
    productDescription:
      'New distinctive eagle-style temple design with pierced design. Distinctive geometric shapes and unique details. Premium design features such as titanium trims',
    distributorEmail: 'mukil.somadas@derigome.com',
  },
  {
    brandName: 'ROAV',
    productName: 'ORIGIN COLLECTION',
    categoryCode: '08',
    categoryName: 'VP-008 Best New Sunglass Model (Popular)',
    distributor: 'ROAV International Company Limited',
    productCode: '08-04',
    productImage: '08-04.jpg',
    pdf: '',
    price: '175',
    ID: '08-04',
    brandLogo: '08-04-logo.jpg',
    productDescription:
      "ROAV, the world's thinnest folding eyewear, was born in Los Angeles by a team of designers, engineers and travelers who believe the best adventures are the ones unplanned, and the best eyewear is the pair you always have with you. We create eyewear that fits anywhere and goes with you everywhere.",
    distributorEmail: 'roaver@roavgalaxy.com',
  },
  {
    brandName: 'WOODYS EYEWEAR',
    productName: 'NOE02',
    categoryCode: '08',
    categoryName: 'VP-008 Best New Sunglass Model (Popular)',
    distributor: 'Woodys Eyewear',
    productCode: '08-05',
    productImage: '08-05.jpg',
    pdf: '',
    price: '192',
    ID: '08-05',
    brandLogo: '08-05-logo.jpg',
    productDescription:
      'NOE02 stands out with its geometric silhouette and modern appeal. Made from Italian acetate, it features dual laminations, contrasting temples, and wood-inlaid tips. The 5-axis OBE hinge ensures comfort, while ZEISS CR39 lenses offer UVA/UVB protection and superb visual clarity.',
    distributorEmail: 'marketing@woodyseyewear.com',
  },
  {
    brandName: 'BFLEX',
    productName: 'BFUN BF030252',
    categoryCode: '09',
    categoryName: 'VP-009 Best New Functional Eyewear (Sports)',
    distributor: 'Gulf Vision Optics LLC',
    productCode: '09-01',
    productImage: '09-01.jpg',
    pdf: '',
    price: '200',
    ID: '09-01',
    brandLogo: '09-01-logo.jpg',
    productDescription:
      "Bflex™ frame temples can rotate up to 360° thanks to the 'Hinge 3.0', a unique industrial innovation that eliminates breakage or deformation at the most critical point. The Siliflex™ joined with the 'Hinges 3.0' is the perfect combination of strength and flexibility.",
    distributorEmail: 'arshad@gulfvisionfzc.com',
  },
  {
    brandName: 'CARRERA',
    productName: 'C SPORT',
    categoryCode: '09',
    categoryName: 'VP-009 Best New Functional Eyewear (Sports)',
    distributor: 'Safilo Middle East FZCO',
    productCode: '09-02',
    productImage: '09-02.jpg',
    pdf: '',
    price: '250',
    ID: '09-02',
    brandLogo: '09-02-logo.jpg',
    productDescription:
      "Carrera's Extreme sunglasses pay homage to the brand's iconic sports heritage. The archival aviator front features a horizontal C logo and the magnetic lateral spoilers provide extra protection and can be removed easily for versatile wear. The branded elastic band ensures secure use.",
    distributorEmail: 'paola.kanta@safilo.com',
  },
  {
    brandName: 'NIKE',
    productName: 'FLYFREE SHIELD',
    categoryCode: '09',
    categoryName: 'VP-009 Best New Functional Eyewear (Sports)',
    distributor: 'Marchon Gulf Fzco',
    productCode: '09-03',
    productImage: '09-03.jpg',
    pdf: '',
    price: '240',
    ID: '09-03',
    brandLogo: '09-03-logo.jpg',
    productDescription:
      'Never let a new environment change how you choose to sport. Meet the latest edition of Nike Flyfree. The Flyfree Shield features a panoramic single-lens design with interchangeable lens options to enhance performance in any setting.Adjustable nose pads and temples provide lasting comfort and support',
    distributorEmail: 'cfullin@marchon.com',
  },
  {
    brandName: 'OAKLEY',
    productName: 'VELO KATO',
    categoryCode: '09',
    categoryName: 'VP-009 Best New Functional Eyewear (Sports)',
    distributor: 'EssilorLuxottica Middle East FZE',
    productCode: '09-04',
    productImage: '09-04.jpg',
    pdf: '',
    price: '350',
    ID: '09-04',
    brandLogo: '09-04-logo.jpg',
    productDescription:
      'Velo Kato™ breaks convention with PhysioMorphic™ Geometry for a close face fit. Its large lens, Unobtainium® nosepad & earsocks, plus flow conditioner tabs create a sleek, no-hinge design that enhances protection, airflow & field of view- keeping you locked in at all times.',
    distributorEmail: 'anikamarie.monfero@ae.luxottica.com',
  },
  {
    brandName: 'ZIRKEL OPTICS',
    productName: 'RIDGE RUNNER',
    categoryCode: '09',
    categoryName: 'VP-009 Best New Functional Eyewear (Sports)',
    distributor: 'Zirkel Holding LLC',
    productCode: '09-05',
    productImage: '09-05.jpg',
    pdf: '',
    price: '229',
    ID: '09-05',
    brandLogo: '09-05-logo.jpg',
    productDescription:
      'Zirkel Ridge Runner pairs ZEISS FUTR LenZ™ optics with an SLS 3D-printed PA11 frame from castor beans. The bio-based, heat-adjustable design delivers strength, flexibility, and fit - proving sustainable additive manufacturing can achieve elite performance.',
    distributorEmail: 'dom@zirkeloptics.com',
  },
  {
    brandName: 'IDEE YOUNG',
    productName: 'SY629',
    categoryCode: '10',
    categoryName: 'VP-010 Best New Functional Eyewear (Children)',
    distributor: 'FourPlus General Trading LLC',
    productCode: '10-01',
    productImage: '10-01.jpg',
    pdf: '',
    price: '65',
    ID: '10-01',
    brandLogo: '10-01-logo.jpg',
    productDescription: 'Model IDY 567-05. Superhero inspired shades to colorful optical.',
    distributorEmail: 'trading@fourplusmedia.com',
  },
  {
    brandName: 'LACOSTE',
    productName: 'L3661',
    categoryCode: '10',
    categoryName: 'VP-010 Best New Functional Eyewear (Children)',
    distributor: 'Marchon Gulf Fzco',
    productCode: '10-02',
    productImage: '10-02.jpg',
    pdf: '',
    price: '109',
    ID: '10-02',
    brandLogo: '10-02-logo.jpg',
    productDescription:
      "A new vibrant and playful optical style designed for boy. Color-Switching Temples! - Unique feature where the rubber temple's module turns around and create different color combinations. Glow in the dark SKU that absorb daylight and make the frame luminous at night, adding a magical touch.",
    distributorEmail: 'cfullin@marchon.com',
  },
  {
    brandName: 'NANOVISTA',
    productName: 'CREW SC',
    categoryCode: '10',
    categoryName: 'VP-010 Best New Functional Eyewear (Children)',
    distributor: 'Gulf Vision Optics LLC',
    productCode: '10-03',
    productImage: '10-03.jpg',
    pdf: '',
    price: '150',
    ID: '10-03',
    brandLogo: '10-03-logo.jpg',
    productDescription:
      "NANOVISTA CREW CLIPON model has all the features of indestructible NANO glasses: resistant, light and super flexible; but now with a magnetic clip to protect the eyes from the sun. Thanks to their blue block and anti-reflective lenses, they will protect children from UV radiation in just one 'clip'.",
    distributorEmail: 'arshad@gulfvisionfzc.com',
  },
  {
    brandName: 'POLAROID',
    productName: 'PLD 8070',
    categoryCode: '10',
    categoryName: 'VP-010 Best New Functional Eyewear (Children)',
    distributor: 'Safilo Middle East FZCO',
    productCode: '10-04',
    productImage: '10-04.jpg',
    pdf: '',
    price: '80',
    ID: '10-04',
    brandLogo: '10-04-logo.jpg',
    productDescription:
      'Made for outdoor adventures, Polaroid has created these shield sunglasses for boys and girls ages 7 to 10. The full-coverage front is composed of a polarized maxi-lens complete with rubberised nose pads. Bold and high-performance, these glasses are stable even when on the move.',
    distributorEmail: 'paola.kanta@safilo.com',
  },
  {
    brandName: 'ROLF EYEWEAR',
    productName: 'WIRE KIDS | HARE',
    categoryCode: '10',
    categoryName: 'VP-010 Best New Functional Eyewear (Children)',
    distributor: 'Rolf produktion GmbH',
    productCode: '10-05',
    productImage: '10-05.jpg',
    pdf: '',
    price: '390',
    ID: '10-05',
    brandLogo: '10-05-logo.jpg',
    productDescription:
      "Colorful, nearly square children's glasses with softly rounded corners. Lightweight and durable, they mix playful charm with everyday practicality. A whimsical twist on a classic silhouette - perfect for young explorers with style and imagination.",
    distributorEmail: 'marketing@rolf-spectacles.com',
  },
  {
    brandName: 'GALFER EYEWEAR',
    productName: 'COLOSSEUM ECO BOX AND MERINO WOOL SOFTCASE',
    categoryCode: '11',
    categoryName: 'VP-011 Best Next-Gen Eco Eyewear Award',
    distributor: 'Galferdexign UG',
    productCode: '11-01',
    productImage: '11-01.jpg',
    pdf: '',
    price: '25',
    ID: '11-01',
    brandLogo: '11-01-logo.jpg',
    productDescription:
      'Our box has been inspired by the Roman Colosseum, handmade in recycled cardboard by artisans in Spain, pays homage to the rich heritage of Lusitania, an ancient part of the Roman Empire, today Extremadura. Softcase is 100% natural merino wool felt, certified traceability, respecting the environment.',
    distributorEmail: 'info@galferdexign.com',
  },
  {
    brandName: 'ROLF EYEWEAR',
    productName: 'FUSION WOOD&BEAN EYEWEAR',
    categoryCode: '11',
    categoryName: 'VP-011 Best Next-Gen Eco Eyewear Award',
    distributor: 'Rolf produktion GmbH',
    productCode: '11-02',
    productImage: '11-02.jpg',
    pdf: '11-02.pdf',
    price: '691',
    ID: '11-02',
    brandLogo: '11-02-logo.jpg',
    productDescription:
      'VIOLA stands out with a bold mono-bridge and angular silhouette, blending modern edge with timeless strength. Sculptural lines and refined proportions give it clarity and character. Minimal detailing highlights its confident design - strength defined, design refined.',
    distributorEmail: 'marketing@rolf-spectacles.com',
  },
  {
    brandName: 'ZEISS',
    productName: 'SUSTAINABLE ZEISS SUNLENS',
    categoryCode: '11',
    categoryName: 'VP-011 Best Next-Gen Eco Eyewear Award',
    distributor: 'ZEISS Vision Care',
    productCode: '11-03',
    productImage: '11-03.jpg',
    pdf: '11-03.pdf',
    price: '0',
    ID: '11-03',
    brandLogo: '11-03-logo.jpg',
    productDescription:
      'ZEISS Sunlens offers a new approach to sun lenses production by introducing not only a sustainable lens material but a more sustainable production process. The whole chain is certified according to independant certification schemes.',
    distributorEmail: 'nathalie.geeroms@zeiss.com',
  },
  {
    brandName: 'ZIRKEL OPTICS',
    productName: 'SAWTOOTH EXPLR',
    categoryCode: '11',
    categoryName: 'VP-011 Best Next-Gen Eco Eyewear Award',
    distributor: 'Zirkel Holding LLC',
    productCode: '11-04',
    productImage: '11-04.jpg',
    pdf: '11-04.pdf',
    price: '499',
    ID: '11-04',
    brandLogo: '11-04-logo.jpg',
    productDescription:
      'Zirkel Sawtooth EXPLR combines ZEISS FUTR LenZ™ optics with a modular subframe system for maximum versatility. Built with bio-based materials, SLS additive manufacturing, and renewable energy, it delivers distortion-free clarity, durability, and sustainable high-performance design.',
    distributorEmail: 'dom@zirkeloptics.com',
  },
  {
    brandName: 'HOYA',
    productName: 'HOYALUX ID MYSELF',
    categoryCode: '12',
    categoryName: 'VP-012 Most Popular Lens (Progressive)',
    distributor: 'Yateem Vision',
    productCode: '12-01',
    productImage: '12-01.jpg',
    pdf: '',
    price: '1350',
    ID: '12-01',
    brandLogo: '12-01-logo.jpg',
    productDescription:
      "Hoyalux iD MySelf Profile is HOYA's advanced progressive lens for the digital age, delivering clear vision at all distances with effortless adaptation. Designed for presbyopic patients who switch frequently between near, intermediate, & far tasks, it blends personalized fitting with cutting-edge technology. Key Features: Five pre-defined Lifestyle Designs: Modern, Adventure, Stable, Detail, & Expert-tailored to individual visual needs. AdaptEase Technology: Improves near & intermediate zones while maintaining sharp distance vision. Binocular Harmonization Technology: Balances differences between eyes for stable, comfortable vision. 3D Binocular Vision: Minimizes peripheral distortion & swaying for a more natural view. Integrated Double Surface Design: Ensures smooth gaze transitions & clear vision across all distances. Simplified Consultation Process: Offline Smart Analysis Questionnaire helps match patients with the ideal design. Hoyalux iD MySelf Profile delivers a personalized visual experience for today's dynamic lifestyles - helping eye care professionals offer comfort, clarity, & premium care.",
    distributorEmail: 'mathews@yateemgroup.ae',
  },
  {
    brandName: 'ZEISS',
    productName: 'SMARTLIFE INDIVIDUAL 3',
    categoryCode: '12',
    categoryName: 'VP-012 Most Popular Lens (Progressive)',
    distributor: 'ZEISS Vision Care',
    productCode: '12-02',
    productImage: '12-02.jpg',
    pdf: '12-02.pdf',
    price: '570',
    ID: '12-02',
    brandLogo: '12-02-logo.jpg',
    productDescription:
      "ZEISS Progressive SmartLife Individual 3 lenses with ZEISS intelligence Augmented DesignTM Technology provide smooth vision from near to far and fast adaptation. They are optimized for the wearer's personal visual behavior and requirements and give the wearer full freedom of vision.",
    distributorEmail: 'nathalie.geeroms@zeiss.com',
  },
  {
    brandName: 'HOYA',
    productName: 'MIYOSMART ',
    categoryCode: '13',
    categoryName: 'VP-013 Most Popular Lens (Best Value)',
    distributor: 'Yateem Vision',
    productCode: '13-01',
    productImage: '13-01.jpg',
    pdf: '',
    price: '450',
    ID: '13-01',
    brandLogo: '13-01-logo.jpg',
    productDescription:
      "HOYA's award-winning myopia management spectacle lens that corrects vision & slows myopia progression in children using patented D.I.M.S. (Defocus Incorporated Multiple Segments) technology. This non-invasive, science-backed solution is trusted worldwide & supported by over 90 studies. Key features: Clinically proven to reduce myopia progression on average by 60% versus standard lenses. Long-term effectiveness sustained over 8 years. Fits standard frames - worn like regular single vision lenses. Award-winning & trusted by millions of parents globally.",
    distributorEmail: 'mathews@yateemgroup.ae',
  },
  {
    brandName: 'STELLEST® - ESSILORLUXOTTICA',
    productName: 'STELLEST®',
    categoryCode: '13',
    categoryName: 'VP-013 Most Popular Lens (Best Value)',
    distributor: 'EssilorLuxottica Middle East FZE',
    productCode: '13-02',
    productImage: '13-02.jpg',
    pdf: '13-02.pdf',
    price: '490',
    ID: '13-02',
    brandLogo: '13-02-logo.jpg',
    productDescription:
      'Essilor® Stellest® lenses correct myopia today while helping protect vision for tomorrow. With HALT tech and 1,021 invisible lenslets, they slow progression by 67% on average while ensuring sharp, comfortable vision. Lightweight, aesthetic, and backed by a 12-month warranty.',
    distributorEmail: 'anikamarie.monfero@ae.luxottica.com',
  },
  {
    brandName: 'ZEISS',
    productName: 'CLEARVIEW FSV BLUEGUARD',
    categoryCode: '13',
    categoryName: 'VP-013 Most Popular Lens (Best Value)',
    distributor: 'ZEISS Vision Care',
    productCode: '13-03',
    productImage: '13-03.jpg',
    pdf: '13-03.pdf',
    price: '121',
    ID: '13-03',
    brandLogo: '13-03-logo.jpg',
    productDescription:
      'With ZEISS ClearView FSV BlueGuard Lenses, wearers can experience excellent vision clarity from the lens center to the periphery, while protected against the harmful blue light. The lenses are flatter, thinner, and provide up to 3 times larger zones of clarity than conventional stock lens designs.',
    distributorEmail: 'nathalie.geeroms@zeiss.com',
  },
  {
    brandName: 'HOYA HI-VISION MEIRYO',
    productName: 'HOYA HI-VISION MEIRYO',
    categoryCode: '14',
    categoryName: 'VP-014 Most Popular Lens Addition (Coating/Value Addition)',
    distributor: 'Yateem Vision',
    productCode: '14-01',
    productImage: '14-01.jpg',
    pdf: '14-01.pdf',
    price: '460',
    ID: '14-01',
    brandLogo: '14-01-logo.jpg',
    productDescription:
      "HOYA's most advanced premium anti-reflective (AR) lens coating, for exceptional optical clarity, durability, & UV protection. It delivers long-lasting lens performance for patients who demand lasting quality. Hi-Vision Meiryo resists daily wear & enhances satisfaction - making it a reliable choice for eye care professionals focused on consistently positive wearer experiences. Superior Clarity that lasts! - longer with 56% lower reflectance than competitors. Best in class surface durability. Up to 2.5x better scratch resistance than major competitor's best coating. Stays easy to clean for more than 5x longer than major competitor's best coating.",
    distributorEmail: 'mathews@yateemgroup.ae',
  },
  {
    brandName: 'RAZÉ CUSTOM LENSES',
    productName: 'DIAMOND CUT LENSES',
    categoryCode: '14',
    categoryName: 'VP-014 Most Popular Lens Addition (Coating/Value Addition)',
    distributor: 'Raze Eyewear Distribution FZCO',
    productCode: '14-02',
    productImage: '14-02.jpg',
    pdf: '',
    price: '800',
    ID: '14-02',
    brandLogo: '14-02-logo.jpg',
    productDescription:
      'We produce Custom Lenses with diamond cut and bevel cut, shape without drilling so our optician can drill for any frame he wants, drilled is also is possible if the frame is chosen already. Transition lenses with gradient base color possible, very rare and hyped. Also uncured lenses possible.',
    distributorEmail: 'info@djraze.com',
  },
  {
    brandName: 'ZEISS',
    productName: 'DURAVISION GOLD UV',
    categoryCode: '14',
    categoryName: 'VP-014 Most Popular Lens Addition (Coating/Value Addition)',
    distributor: 'ZEISS Vision Care',
    productCode: '14-03',
    productImage: '14-03.jpg',
    pdf: '14-03.pdf',
    price: '56',
    ID: '14-03',
    brandLogo: '14-03-logo.jpg',
    productDescription:
      'ZEISS DuraVision Gold UV offers exceptionally clear and hassle-free vision together with better cleanability and superior scratch resistance.Integrating ZEISS CleanGuard makes lenses easier and faster to clean.The coating enhances lens clarity in low-light conditions, and diminishes lens yellowness.',
    distributorEmail: 'nathalie.geeroms@zeiss.com',
  },
  {
    brandName: 'ACUVUE',
    productName: 'OASYS MAX 1-DAY',
    categoryCode: '15',
    categoryName: 'VP-015 Most Popular Oph. Contact Lens (Prescription)',
    distributor: 'Johnson & Johnson Middle East FZ LLC',
    productCode: '15-01',
    productImage: '15-01.jpg',
    pdf: '',
    price: '15',
    ID: '15-01',
    brandLogo: '15-01-logo.jpg',
    productDescription:
      "ACUVUE® OASYS MAX 1-Day daily disposable lenses with blue-violet light filter, for today's intense lifestyle.",
    distributorEmail: 'ajha10@its.jnj.com',
  },
  {
    brandName: 'ADORE',
    productName: 'GIORNO',
    categoryCode: '15',
    categoryName: 'VP-015 Most Popular Oph. Contact Lens (Prescription)',
    distributor: 'Eyemed Techologies srl',
    productCode: '15-02',
    productImage: '15-02.jpg',
    pdf: '15-02.pdf',
    price: '',
    ID: '15-02',
    brandLogo: '15-02-logo.jpg',
    productDescription: 'Coloured lenses with BioMoist.',
    distributorEmail: 'f.ceravolo@eyemed.it',
  },
  {
    brandName: 'FACELOOX',
    productName: 'CLEAR + MPC',
    categoryCode: '15',
    categoryName: 'VP-015 Most Popular Oph. Contact Lens (Prescription)',
    distributor: 'Care Optic Ltd',
    productCode: '15-03',
    productImage: '15-03.jpg',
    pdf: '',
    price: '12',
    ID: '15-03',
    brandLogo: '15-03-logo.jpg',
    productDescription: 'Faceloox monthly clear lenses 4 pcs in a box.',
    distributorEmail: 'sabah.alfalahi@gmail.com',
  },
  {
    brandName: 'SEED',
    productName: '1 DAY PURE',
    categoryCode: '15',
    categoryName: 'VP-015 Most Popular Oph. Contact Lens (Prescription)',
    distributor: 'Eye Focus Optical Supplies',
    productCode: '15-04',
    productImage: '15-04.jpg',
    pdf: '',
    price: '30',
    ID: '15-04',
    brandLogo: '15-04-logo.jpg',
    productDescription:
      "SEED 1dayPure moisture is a daily disposable contact lens made in Japan that contains alginic acid as a natural moisturizing agent. Using SEED's original zwitterionic material 'SIB', this contact lens contains UV absorber that reduces the absorption of UV rays.",
    distributorEmail: 'info@eyefocusuae.com',
  },
  {
    brandName: 'ADORE',
    productName: 'GIORNO',
    categoryCode: '16',
    categoryName: 'VP-016 Most Popular Coloured Contact Lens (Cosmetic)',
    distributor: 'Eyemed Techologies srl',
    productCode: '16-01',
    productImage: '16-01.jpg',
    pdf: '16-01.pdf',
    price: '',
    ID: '16-01',
    brandLogo: '16-01-logo.jpg',
    productDescription: 'Coloured contact lenses with new BioMoist.',
    distributorEmail: 'f.ceravolo@eyemed.it',
  },
  {
    brandName: 'ROSA BELLE',
    productName: 'COLORED CONTACT LENSES',
    categoryCode: '16',
    categoryName: 'VP-016 Most Popular Coloured Contact Lens (Cosmetic)',
    distributor: 'Eye Focus Optical Supplies',
    productCode: '16-02',
    productImage: '16-02.jpg',
    pdf: '',
    price: '30',
    ID: '16-02',
    brandLogo: '16-02-logo.jpg',
    productDescription:
      'Our colored contact lenses are manufactured with latest technology in addition to a unique color blend to suit all desires.',
    distributorEmail: 'info@eyefocusuae.com',
  },
  {
    brandName: 'VIVALOOK',
    productName: 'VIVALOOK',
    categoryCode: '16',
    categoryName: 'VP-016 Most Popular Coloured Contact Lens (Cosmetic)',
    distributor: 'Care Optic Ltd',
    productCode: '16-03',
    productImage: '16-03.jpg',
    pdf: '',
    price: '14',
    ID: '16-03',
    brandLogo: '16-03-logo.jpg',
    productDescription: '10 pcs in a box.',
    distributorEmail: 'sabah.alfalahi@gmail.com',
  },
  {
    brandName: 'EYESHAKER',
    productName: 'THE SET',
    categoryCode: '17',
    categoryName: 'VP-017 Best Value Enhancer (Retail)',
    distributor: 'Eyeworks GmbH',
    productCode: '17-01',
    productImage: '17-01.jpg',
    pdf: '17-01.pdf',
    price: '35',
    ID: '17-01',
    brandLogo: '17-01-logo.jpg',
    productDescription:
      'Eyeshaker turns eyewear care into a unique retail experience. A stylish, patented tool that cleans lenses and frames in seconds, streak-free, without risk. It drives repeat sales with refills, builds loyalty, and elevates eyewear retail with real added value.',
    distributorEmail: 'social@eyeshaker.com',
  },
  {
    brandName: 'GLASKLAR',
    productName: 'GLASKLAR BOTTLES NEW COLLECTION',
    categoryCode: '17',
    categoryName: 'VP-017 Best Value Enhancer (Retail)',
    distributor: 'Glasklar International B.V.',
    productCode: '17-02',
    productImage: '17-02.jpg',
    pdf: '17-02.pdf',
    price: '2.39',
    ID: '17-02',
    brandLogo: '17-02-logo.jpg',
    productDescription:
      'Our new full-color sprayers match each bottle shade perfectly and expand the design range to over 500 color combinations. A stylish upgrade for optical shops - individual, modern, and brand-enhancing. The classic sprayers remain available.',
    distributorEmail: 'oliver.bartsch@glasklar.com',
  },
  {
    brandName: 'PRIME CASES',
    productName: 'CASES AND ACCESSORIES',
    categoryCode: '17',
    categoryName: 'VP-017 Best Value Enhancer (Retail)',
    distributor: 'Prime Cases',
    productCode: '17-03',
    productImage: '17-03.jpg',
    pdf: '',
    price: '20',
    ID: '17-03',
    brandLogo: '17-03-logo.jpg',
    productDescription:
      "Wholesale sales of eco-leather cases and accessories for the eyewear and optical industry, with products ranging from entry-level to premium cases and accessories. We have over 70 models of cases and accessories in our catalog, and we can also develop other models according to the customer's wishes.",
    distributorEmail: 'vendasprimecases@gmail.com',
  },
  {
    brandName: 'RAYBAN',
    productName: 'RAY-BAN META',
    categoryCode: '17',
    categoryName: 'VP-017 Best Value Enhancer (Retail)',
    distributor: 'EssilorLuxottica Middle East FZE',
    productCode: '17-04',
    productImage: '17-04.jpg',
    pdf: '17-04.pdf',
    price: '360',
    ID: '17-04',
    brandLogo: '17-04-logo.jpg',
    productDescription:
      'From Hollywood to hip-hop, the Wayfarer evolves with AI-enhanced wearable tech. Ray-Ban Meta Wayfarer glasses let you listen, call, capture & livestream - seamlessly built into the classic frame. With Transitions® lenses, stay connected & stylish from day to night.',
    distributorEmail: 'anikamarie.monfero@ae.luxottica.com',
  },
  {
    brandName: 'ZEISS',
    productName: 'MYOPIA KIDS CORNER',
    categoryCode: '17',
    categoryName: 'VP-017 Best Value Enhancer (Retail)',
    distributor: 'ZEISS Vision Care',
    productCode: '17-05',
    productImage: '17-05.jpg',
    pdf: '17-05.pdf',
    price: '4765',
    ID: '17-05',
    brandLogo: '17-05-logo.jpg',
    productDescription:
      'The ZEISS Myopia Kids corner is designed for eye clinics and optical stores and serves as a tool to help parents understand the benefits of MyoCare lenses.It creates a powerful platform for ECPs to explain how ZEISS MyoCare lenses are an effective solution for managing myopia progression in children.',
    distributorEmail: 'nathalie.geeroms@zeiss.com',
  },
  {
    brandName: 'COBURN TECHNOLOGIES',
    productName: 'VELOCITY TT',
    categoryCode: '18',
    categoryName: 'VP-18 Best Value Enhancer (Lab)',
    distributor: 'Coburn Technologies Pte Ltd',
    productCode: '18-01',
    productImage: '18-01.jpg',
    pdf: '',
    price: '40000',
    ID: '18-01',
    brandLogo: '18-01-logo.jpg',
    productDescription:
      'The revolutionary Velocity TT Spin Coating System redefines optical coating standards, offering a compact and affordable solution for small and medium-sized labs. With Velocity TT, labs can coat their own lenses with hard coating, optimizing costs and time.',
    distributorEmail: 'nram@coburntechnologies.com',
  },
  {
    brandName: 'ESSILOR INSTRUMENTS',
    productName: 'ES PRO™ 800M',
    categoryCode: '18',
    categoryName: 'VP-18 Best Value Enhancer (Lab)',
    distributor: 'EssilorLuxottica Middle East FZE',
    productCode: '18-02',
    productImage: '18-02.jpg',
    pdf: '18-02.pdf',
    price: '93000',
    ID: '18-02',
    brandLogo: '18-02-logo.jpg',
    productDescription:
      'The ES PRO™ 800M boosts in-lab productivity with precision, speed, and durability.Its SuperVeloce™ cycle cuts edging time by 41%, delivering lenses in under a minute.With 25% faster edging, 57% reduced milling,and a 6x longer tool life, it ensures high-performance finishing across all materials.',
    distributorEmail: 'anikamarie.monfero@ae.luxottica.com',
  },
  {
    brandName: 'MEI',
    productName: 'EASYBUDDY',
    categoryCode: '18',
    categoryName: 'VP-18 Best Value Enhancer (Lab)',
    distributor: 'MEI SRL',
    productCode: '18-03',
    productImage: '18-03.jpg',
    pdf: '18-03.pdf',
    price: '',
    ID: '18-03',
    brandLogo: '18-03-logo.jpg',
    productDescription:
      'EasyBuddy features an innovative robotic arm, equipped with an integrated cobot, designed to feed your EasyFit Trend lens edger with increasing autonomy from manual interventions, significantly boosting your productivity by managing up to 5 input trays and 5 output trays simultaneously.',
    distributorEmail: 'marketing@meisystem.com',
  },
  {
    brandName: 'MEI',
    productName: '4D TRACE',
    categoryCode: '18',
    categoryName: 'VP-18 Best Value Enhancer (Lab)',
    distributor: 'MEI SRL',
    productCode: '18-04',
    productImage: '18-04.jpg',
    pdf: '18-04.pdf',
    price: '',
    ID: '18-04',
    brandLogo: '18-04-logo.jpg',
    productDescription:
      '4D Trace is an ALL-IN-ONE device that integrates a commercial tracer with the MEI Flawless Gauge profile-matching device, a barcode scanner and a screen. It dramatically improves the fitting rate of all frames in which the bevel profile and the frame groove profile do not match perfectly.',
    distributorEmail: 'marketing@meisystem.com',
  },
  {
    brandName: 'PMD MODULO ONE',
    productName: 'PMD MODULO ONE',
    categoryCode: '18',
    categoryName: 'VP-18 Best Value Enhancer (Lab)',
    distributor: 'Schneider GmbH & Co. KG',
    productCode: '18-05',
    productImage: '18-05.jpg',
    pdf: '18-05.pdf',
    price: '',
    ID: '18-05',
    brandLogo: '18-05-logo.jpg',
    productDescription:
      'The powerful quality inspection system PMD Modulo ONE is the only measuring device that checks the lens automatically in-line and on the block without interrupting production. It eliminates the drastic time gap between surfacing and quality inspection.',
    distributorEmail: 'l.djebali@schneider-om.com',
  },
]
